import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';

import ErrorBoundary from '@/app/ErrorBoundary';
import { queryClient } from '@/app/queryClient';
import AppRouter from '@/routes/AppRouter';

const App: FC = () => (
  <ErrorBoundary scope="app">
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
